export default {"src":"/_next/static/media/BASE.9fdd3cca.svg","height":18,"width":18};